import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountdownService {
  private countdownSubject = new BehaviorSubject<{
    message: string;
    seconds: number;
    callback?: () => void;
  } | null>(null);

  countdown$ = this.countdownSubject.asObservable();

  show(message: string, seconds: number, callback?: () => void): void {
    this.countdownSubject.next({ message, seconds, callback });

    const interval = setInterval(() => {
      seconds--;
      this.countdownSubject.next({ message, seconds, callback });

      if (seconds <= 0) {
        clearInterval(interval);
        this.hide();
        callback?.();
      }
    }, 1000);
  }

  hide(): void {
    this.countdownSubject.next(null);
  }
}
